import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { useCallback } from "react";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.28em] ${
      dark ? "text-[#9ec6ee]" : "text-[#1a6fc4]"
    } ${className}`}
  >
    <span
      className={`h-px w-6 ${dark ? "bg-[#9ec6ee]" : "bg-[#5aa72f]"}`}
    />
    {children}
  </span>
);

export function useScrollTo() {
  const lenis = useLenis();
  return useCallback(
    (id) => {
      const el = document.getElementById(id);
      if (!el) return;
      if (lenis) {
        lenis.scrollTo(el, { offset: -72, duration: 1.1 });
      } else {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    [lenis],
  );
}
